import React from 'react';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  Cell,
} from 'recharts';
import { useTheme } from '@mui/material';
import type { Workload } from '../../services/types';

interface VMUtilizationBarChartProps {
  data: Array<{ runId: string; vmCount: number; workload: Workload; course: string }>;
}

export const VMUtilizationBarChart: React.FC<VMUtilizationBarChartProps> = ({ data }) => {
  const theme = useTheme();

  // Limit to last 10 runs for readability
  const limitedData = data.slice(0, 10).reverse();

  return (
    <ResponsiveContainer width="100%" height={300}>
      <BarChart data={limitedData} margin={{ top: 5, right: 30, left: 0, bottom: 5 }}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis
          dataKey="runId"
          tick={{ fontSize: 11 }}
          angle={-45}
          textAnchor="end"
          height={80}
        />
        <YAxis tick={{ fontSize: 12 }} label={{ value: 'VM Anzahl', angle: -90, position: 'insideLeft' }} />
        <Tooltip
          content={({ active, payload }) => {
            if (active && payload && payload.length) {
              const data = payload[0].payload;
              return (
                <div
                  style={{
                    backgroundColor: theme.palette.background.paper,
                    border: `1px solid ${theme.palette.divider}`,
                    padding: '10px',
                    borderRadius: '4px',
                  }}
                >
                  <p style={{ margin: 0, fontWeight: 'bold' }}>{data.runId}</p>
                  <p style={{ margin: 0 }}>Kurs: {data.course}</p>
                  <p style={{ margin: 0 }}>Workload: {data.workload.toUpperCase()}</p>
                  <p style={{ margin: 0, color: theme.palette.primary.main }}>
                    VMs: {data.vmCount}
                  </p>
                </div>
              );
            }
            return null;
          }}
        />
        <Legend />
        <Bar dataKey="vmCount" name="VM Anzahl" radius={[8, 8, 0, 0]}>
          {limitedData.map((entry, index) => (
            <Cell
              key={`cell-${index}`}
              fill={
                entry.workload === 'cam'
                  ? theme.palette.primary.main
                  : entry.workload === 'it'
                  ? theme.palette.info.main
                  : theme.palette.secondary.main
              }
            />
          ))}
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  );
};
